import Vue from 'vue';
import querystring from 'querystring';
import * as Cursos from '@lib/Cursos';
import { Curso, Participante } from '@lib/Cursos/Curso.nav';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Controlador as Model } from './controlador';
import { SignalDispatcher, SimpleEventDispatcher } from 'strongly-typed-events';
import { EventBus, Utiles, } from '@/__env/pluggins/event-bus';
import { isNumber } from 'util';
import { Resultado } from '@/__env/lib/Cursos/Resultado';



export class ControladorDeCurso
{
    public get Controlador() { return Model; }
    public Curso: Curso = new Curso();
    public Resultado: Resultado = new Resultado();

    protected seleccionado: Participante;
    public get Seleccionado() { return this.seleccionado; };
    public set Seleccionado( x: Participante )
    {
        this.seleccionado = x;
        if ( this.seleccionado ) { this.Vista.SubModo = 'resultados'; }
        else { this.Vista.SubModo = 'vacio'; }
    };

    public async Iniciar( curso: number | Curso )
    {
        this.Vista.Estado = 'cargando';
        if ( isNumber( curso ) )
        {
            this.Curso = await Curso.create( curso );
        } else
        {
            this.Curso = curso;
        }

        if ( !this.Curso )
        {
            Utiles.Notificaciones.Error( 'No se encontro el recurso' );
            this.Cerrar();

        }

        //this.Resultado = await Resultado.create( this.Curso.Id );
        await this.Curso.cargarParticipantes();

        this.Vista.Estado = 'ok';
        this.Vista.Query = this.Curso.Existe ? 'id=' + this.Curso.Id : '' + 'modo=crear&item=nuevo';
    }

    public async Cerrar()
    {
        this.Controlador.Vista.Modo = 'lista';
    }


    public readonly Vista = new Vista();
}

type Modo =
    string |
    'vacio' |
    'resumen' |
    'resultado' |
    'crear'

    ;

type SubModo =
    'vacio' |
    'resultados' |
    'notificaciones';
'chat'
    ;

type Estado = 'ok' | 'cargando' | 'error';

class Vista
{
    protected query: string = '';
    public set Query( x: string )
    {
        this.query = x;
        Utiles.setQuery( this.query );
    }
    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    protected submodo: SubModo = 'vacio';
    get SubModo(): SubModo { return this.submodo; }
    set SubModo( m: SubModo ) { this.submodo = m; this._onSubModo.dispatch(); }
    private _onSubModo = new SignalDispatcher();
    public get onSubModo() { return this._onSubModo.asEvent(); }

    protected modo: Modo = 'resumen';
    get Modo(): Modo { return this.modo; }
    set Modo( m: Modo ) { this.modo = m; this._onModo.dispatch(); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }
}


const Controlador = new ControladorDeCurso();
export { Controlador };

